import { captureException } from "@sentry/react";
import { useEffect, useState } from "react";
import Map, { IDetour, IPOI } from "./map";

interface AppProps {
  detourId?: string | null;
  poiId?: string | null;
  fase?: number | null;
  className?: string;
  showDetours?: boolean;
  showPois?: boolean;
  center?: string;
}

function App({
  detourId = null,
  poiId = null,
  fase = null,
  className = "",
  showDetours = false,
  showPois = false,
  center = "52.091736,4.638530800000001", // hardcoded for now, will be updated with the actual center of the organisation
}: AppProps) {
  const [searchParams] = useState(new URLSearchParams(window.location.search));
  const [detours, setDetours] = useState<IDetour[]>([]);
  const [pois, setPois] = useState<IPOI[]>([]);
  const [defaultCenter] = useState(() => {
    const [lat, lng] = center.split(",");
    return { lat: parseFloat(lat), lng: parseFloat(lng) };
  });

  const fetchData = async (endpoint: string, setter: (data: any) => void) => {
    try {
      const response = await fetch(`${endpoint}?${searchParams.toString()}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setter(data);
    } catch (error) {
      console.error(`Error fetching data from ${endpoint}:`, error);
      captureException(error);
      setter([]);
    }
  };

  useEffect(() => {
    if (showDetours) {
      const endpoint = detourId ? `/omleidingennet/detours/${detourId}` : "/omleidingennet/detours";
      fetchData(endpoint, (data) => setDetours(data.detours));
    }
  }, [showDetours, searchParams, detourId]);

  useEffect(() => {
    if (showPois) {
      const endpoint = poiId ? `/omleidingennet/pois/${poiId}` : "/omleidingennet/pois";
      fetchData(endpoint, (data) => setPois(data.pois));
    }
  }, [showPois, searchParams, poiId]);

  return (
    <Map
      detours={detours}
      pois={pois}
      fase={fase}
      showOthers={detours.length !== 1}
      className={className}
      center={defaultCenter}
    />
  );
}

export default App;
